import { Link } from "gatsby";
import React, { ReactNode } from "react"
import * as img from './../../images/export';

type ITopNavChild = {
  icon?: string
  firstChild?: boolean // for remove first child padding
  endChild?: boolean // for remove border end
  smEndChild?: boolean
  iconHeight?: number
  reverse?: boolean
  to?: string
  href?: string
  onClick?: () => void
  title?: string
  isActive?: boolean
  resetPadding?: boolean
  customRender?: () => ReactNode;
}

export const TopNavChild: React.FC<ITopNavChild> = props => {
  const renderChildTemplate = () => (
    <a href={props.href || "#"} onClick={props.onClick}
      className={"flexed " + (props.reverse && "row-reversed")}
      title={props.title}>
      <img
        src={props.icon}
        style={{
          padding: props.reverse
            ? `0 0.5rem 0 ${props.firstChild ? "0" : "1.6rem"}`
            : `0 ${props.firstChild ? "0" : "1.6rem"} 0 0.5rem`,
          height: props.iconHeight || 20
        }}
      />
      <span
        className="iran-sans-light"
        style={{
          paddingInlineEnd: props.reverse ? undefined : "1.6rem",
          paddingInlineStart: props.reverse ? "1.6rem" : undefined,
          color: "var(--pre-text-color)",
          fontSize: "0.85rem"
        }}
      >
        {props.children}
      </span>
    </a>
  )
  return (
    props.customRender ? <div
      onClick={props.onClick}
      title={props.title}
      style={{
        height: "100%",
        padding: props.resetPadding ? "0" : "1 0",
      }}
    >
      <div
        style={{
          flexDirection: props.reverse ? "row-reverse" : "row",
          alignItems: "center",
          borderInlineEnd: props.endChild ? "" : `1px solid var(--silver)`,
          justifyContent: props.reverse ? "flex-end" : "flex-start",
          height: "100%"
        }}
        className="flexed"
      >
        {props.customRender()}
      </div>
    </div> : renderChildTemplate()
  )
}

export type TIsActiveTopNav = "main_page" | "dashboard" | "profile"

interface ITopNav {
  isActiveTopNav?: TIsActiveTopNav
}

export const TopNav = ({ isActiveTopNav }: ITopNav) => {
  return (
    <div
      style={{
        backgroundColor: "var(--pre-top-nav-bg-color)",
        height: "3rem",
        padding: "0.5rem 0",
        justifyContent: "space-between",
      }}
      className="flexed align-c"
    >
      <div className="flexed align-c h-100 justify-start">
        <TopNavChild title="میدان ولیعصر، خیابان مینو، تقاطع خیابان مظفر، ساختمان ۱۰۵" icon={img.pre_location}>
          میدان ولیعصر، خیابان مینو، تقاطع خیابان مظفر، ساختمان ۱۰۵
        </TopNavChild>
        <TopNavChild title="021-91090130" icon={img.pre_phone}
          href="tel:00982191090130">021-91090130</TopNavChild>
        <TopNavChild title="info@digimaliat.com" icon={img.pre_email} endChild
          href="mailto:info@digimaliat.com">info@digimaliat.com</TopNavChild>
      </div>
      <div className="flexed align-c h-100 justify-start">
        <TopNavChild customRender={() => {
          const iconHeight = "1.2rem";
          const iconMargin = "0.7rem";
          return <div className="flexed align-c">
            <a href="https://www.aparat.com/digimaliat" target="_blank" className="flexed">
              <img src={img.pre_aparat} style={{ height: iconHeight, marginInlineEnd: iconMargin }} />
            </a>
            <a href="https://t.me/digimaliat" target="_blank" className="flexed">
              <img src={img.pre_telegram} style={{ height: iconHeight, marginInlineEnd: iconMargin }} />
            </a>
            <a href="https://instagram.com/digimaliat" target="_blank" className="flexed">
              <img src={img.pre_instagram} style={{ height: iconHeight, marginInlineEnd: iconMargin }} />
            </a>
          </div>
        }}>
        </TopNavChild>
        <TopNavChild title="persian" icon={img.pre_network} reverse>
          persian
        </TopNavChild>
      </div>
    </div>
  )
}
